import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";

import { RoutingPath } from "@core/enums/routing-path";
import { AuthService } from "@core/services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.authService.isAuthenticated) {
      return true;
    }

    return this.router.createUrlTree([`/${RoutingPath.Login}`]);
  }
}
